import { Component, createRef } from "react";
import {
  DKLine,
  DKLabel,
  DKButton,
  DKIcons,
  showAlert,
} from "deskera-ui-library";
import UserManager from "../../../managers/UserManager";

export interface IMessageComposerProps {
  stepData?: any;
  onClose: () => void;
  onSave: (data) => void;
}

export interface IMessageComposerState {
  data: { body: string };
}

class MessageComposer extends Component<
  IMessageComposerProps,
  IMessageComposerState
> {
  default_fromName = UserManager.getUserTenantName() || "Deskera Team";
  default_fromContact = "+15125374129";
  default_message = ``;
  data = this.props.stepData?.configuration || null;
  messageContentRef: React.RefObject<HTMLTextAreaElement> = createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: {
        body: this.data?.body || this.default_message,
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: IMessageComposerProps) {
    if (nextProps.stepData?.configuration !== this.state.data) {
      this.data = nextProps.stepData?.configuration;
      this.setState({
        data: {
          body: this.data?.body || this.default_message,
        },
      });
    }
  }

  getDataToSave = () => {
    const contentContainer = this.messageContentRef.current;
    return contentContainer?.value || this.default_message;
  };

  updateData = (valueKey: string, newValue: string) => {
    const data_new = { ...this.state.data };
    data_new[valueKey] = newValue;
    this.setState({ data: data_new });
  };

  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////

  renderHeader() {
    return (
      <div
        className="row justify-content-between pt-s pb-s bg-gray3 p-h-m"
        style={{ height: 45 }}
      >
        <DKLabel text="New Message" className="fw-m" />
        <DKButton
          icon={DKIcons.ic_close}
          className=""
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  renderInputField(title: string, value: string) {
    const height = 45;
    return (
      <div className="row p-h-l" style={{ height: 45 }}>
        <DKLabel text={title} className="text-wrap-none text-gray width-auto" />
        <input
          value={value}
          className="flex-1 ml-m border-none fs-r text-gray"
          style={{ outline: "none", height: height - 3 }}
          readOnly={true}
        />
      </div>
    );
  }

  renderTopSection() {
    return (
      <div className="parent-width">
        <DKLine />
        {this.renderInputField("From:", this.default_fromName)}
        <DKLine />
        {/* {this.renderInputField("From Contact", this.default_fromContact)}
        <DKLine /> */}
      </div>
    );
  }

  renderBody() {
    return (
      <div
        id="message-body"
        className="row align-items-start p-l flex-1 border-m-b"
      >
        <textarea
          className="parent-height parent-width border-none hide-outline fs-r"
          style={{
            fontFamily: "inherit",
          }}
          onChange={(e) => this.updateData("body", e.target.value)}
          value={this.state.data.body}
          placeholder="Compose a message.."
          ref={this.messageContentRef}
        ></textarea>
      </div>
    );
  }

  renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-m mt-m" style={{ height: 60 }}>
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => {
            const messageContent = this.getDataToSave();
            if (messageContent) {
              this.props.onSave({ body: messageContent });
              this.props.onClose();
            } else {
              showAlert(
                `Message not found`,
                `Please compose a message to be sent on whatsapp.`
              );
            }
          }}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="transparent-background">
        <div
          className="column popup-window"
          style={{
            padding: 0,
            width: 500,
            height: 350,
            maxWidth: "90vw",
            maxHeight: "100vh",
          }}
        >
          {this.renderHeader()}
          {this.renderTopSection()}
          {this.renderBody()}
          {this.renderBottom()}
        </div>
      </div>
    );
  }
}

export default MessageComposer;
